import React from 'react';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../../../mobx/rootStore';
import ResponsiveHeader from '../../../../../component/responsiveHeader';
import IconButton from '../../../../../component/button/iconButton';
import { Header, TaskContainer, HeaderTitle, ProjectName } from '../styles';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../../../global/constants';
import { ProjectModel } from '../../../../../mobx/models/project';

interface TaskHeaderProps {
  onClickBackIcon: () => void;
  onClickProjectName: () => void;
  currentProject: ProjectModel | null;
  isTaskDetailPreview?: boolean;
  renderHeaderIcons: React.ReactNode;
}

// Isolated observer for the mobile header title.
// Keeping this in its own observer prevents TaskDetail from tracking taskDetails.name,
// so typing in the task title only re-renders this small component instead of the whole screen.
const MobileTaskTitle = observer(() => {
  const { currentTask: taskDetails } = rootStore.taskStore;
  const { currentProject } = rootStore.projectStore;
  return <ResponsiveHeader subTitle={currentProject?.name || ''} title={taskDetails?.name || ''} noMargin={true} />;
});

const DesktopHeader = (props: TaskHeaderProps) => {
  const { onClickBackIcon, onClickProjectName, currentProject, isTaskDetailPreview, renderHeaderIcons } = props;

  return (
    <Header className='web-header' isTaskDetailPreview={isTaskDetailPreview}>
      <TaskContainer>
        <HeaderTitle>
          <IconButton
            iconName='new-back-arrow-icon'
            size={ICON_BUTTON_SIZE.MEDIUM}
            variant={ICON_BUTTON_TYPE.TERTIARY}
            onClick={onClickBackIcon}
          />
          <ProjectName onClick={onClickProjectName}>{currentProject?.name}</ProjectName>
        </HeaderTitle>
        {renderHeaderIcons}
      </TaskContainer>
    </Header>
  );
};

export { MobileTaskTitle, DesktopHeader };
